import { createApp } from "vue";
import App from "./App.vue";
import { createRouter, createWebHistory } from "vue-router";
import HisseVerileri from "./components/HisseVerileri.vue";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "HisseVerileri",
      component: HisseVerileri,
    },
  ],
});

const app = createApp(App);
app.use(router);
app.mount("#app");
